import { hyperdbTriggers } from 'hyperdb-utils';
import * as config from '../../../../config';

export default hyperdbTriggers({ config,
  namespace: 'AUTOMATIC_EMAIL',
  entryPoint: '/automatic-sendings',
  collectionName: 'email_automatic_sendings',
  querySearchListing: [
    ['name', 'type', 'activated'],
    { order: { id: 'asc' } }
  ],
  successMessageCreate: 'Automatic email created',
  successMessageUpdate: 'Automatic email updated',
  successMessageDelete: 'Automatic email deleted',
});



// WEBPACK FOOTER //
// ./src/frontend/modules/email/automatic-sending/triggers.js